// removed by extract-text-webpack-plugin
module.exports = {"base":"_3836O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainLayout/MainLayout.scss
// module id = 1895
// module chunks = 0